export * from './dealer-type-add-edit.component';
export * from './dealer-type-list.component';
